import { Reducer } from 'redux'
import { fromJS } from 'immutable'
import { IMovimientos } from './../models'
import * as TYPES from './../actionTypes'

export const initialState: IMovimientos = fromJS({
  movimientos: [],
  featuredMovimientos: [],
  movimiento: {
    protagonistas: [],
  },
})

const movimientosReducer: Reducer<IMovimientos> = (state = initialState, action) => {
  switch (action.type) {
    case TYPES.SET:
      return state.merge(action.payload)
    case TYPES.CONTENT.TRIGGER:
      return state.set('loading', true)
    case TYPES.CONTENT.SUCCESS:
      return state.merge(action.payload)
    case TYPES.CONTENT.FAILURE:
      return state.set('error', action.payload)
    case TYPES.CONTENT.FULFILL:
      return state.set('loading', false)
    case TYPES.GET.TRIGGER:
      return state.set('loading', true)
    case TYPES.GET.SUCCESS:
      return state.merge(action.payload)
    case TYPES.GET.FAILURE:
      return state.set('error', action.payload)
    case TYPES.GET.FULFILL:
      return state.set('loading', false)
    default:
      return state
  }
}

export default movimientosReducer
